import styled from 'styled-components';

export const Terms = styled.div`
  font-size: 14px;
`;

